import { TableBody } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {getFormData, setData} from '../../store/slices/formDataSlice';
import { BlackCellBorderWhite, DarkGreyCell, GreenCell, InstyleTable, StyledTableRow, TableInput, TableSelect } from "../Page/TableStyles"

export default function InputTable(props) {

    const dispatch = useDispatch();
    const formData = useSelector(getFormData);
    const allProducts = formData.allProducts;

    const updateFormData = (key, value) => {
        dispatch(setData({
            prop: key,
            value: value
        }));
    }


    return (
        <>
            <div>
                <InstyleTable size='small' style={{maxWidth: '320px', margin: 'auto'}}>
                    <TableBody>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Office</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)', padding: '0 16px'}}>
                                <TableSelect value={formData.officeName} onChange={(e) => updateFormData('officeName', e.target.value)} style={{width: '100%'}}>
                                    {
                                        Object.keys(props.sunHours).map(k => {
                                            // if ( k === formData.officeName) {
                                            //     return <option value={k} selected key={`office-${k}`}>{k}</option>
                                            // }
                                            return <option value={k} key={`office-${k}`}>{k}</option>
                                        })
                                    }
                                </TableSelect>
                            </GreenCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Peak Sun Hours</BlackCellBorderWhite>
                            <DarkGreyCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                {
                                    props.sunHours[formData.officeName]
                                }
                            </DarkGreyCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>System Size(kW)</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)', padding: '0 16px'}}>
                                <TableInput type='number'
                                    key="system_size"
                                    value={formData.systemSize.toString()}
                                    onChange={(e) => updateFormData('systemSize', parseFloat(e.target.value) || 0.0)}
                                    min={0}
                                    step={0.1}
                                    style={{width: '100%'}}
                                />
                            </GreenCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Daytime Usage</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                <TableInput type='number'
                                    value={formData.daytimeUsage.toString()}
                                    onChange={(e) => updateFormData('daytimeUsage', parseInt(e.target.value) || 0)}
                                    min={0}
                                    max={100}
                                    step={1}
                                    style={{width: '100%'}}
                                />
                            </GreenCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Solar Exported</BlackCellBorderWhite>
                            <DarkGreyCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                <TableInput type='number'
                                    value={100 - formData.daytimeUsage}
                                    disabled
                                    style={{width: '100%', color: 'white'}}
                                />
                            </DarkGreyCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Power Price(kW)</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                <TableInput type={'number'}
                                    value={formData.powerPrice.toString()}
                                    onChange={(e) => updateFormData('powerPrice', parseFloat(e.target.value) || 0.0)}
                                    min={0}
                                    max={1}
                                    step={0.01}
                                    style={{width: '100%'}}
                                />
                            </GreenCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Feed in Tariff</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                <TableInput type={'number'}
                                    value={formData.feedInTariff.toString()}
                                    onChange={(e) => updateFormData('feedInTariff', parseFloat(e.target.value) || 0.0)}
                                    min={0}
                                    max={1}
                                    step={0.01}
                                    style={{width: '100%'}}
                                />
                            </GreenCell>
                        </StyledTableRow>
                    </TableBody>
                </InstyleTable>
            </div>
            <div>
                <InstyleTable size='small' style={{maxWidth: '320px', margin: 'auto'}}>
                    <TableBody>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Date</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                <TableInput type={'date'}
                                    value={formData.saleDate}
                                    onChange={(e) => updateFormData('saleDate', e.target.value)}
                                    style={{width: '100%'}}
                                />
                            </GreenCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Consultant Name</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>{formData.repName}</GreenCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Customer Name</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                <TableInput type={'text'}
                                    value={formData.customerName}
                                    onChange={(e) => updateFormData('customerName', e.target.value)}
                                    style={{width: '100%'}}
                                    placeholder={'Enter name'}
                                />
                            </GreenCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>System Loss Factor</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                <TableInput type={'number'}
                                    value={formData.systemLossFactor}
                                    onChange={(e) => updateFormData('systemLossFactor', parseInt(e.target.value) || 0)}
                                    min={0}
                                    max={100}
                                    step={1}
                                    style={{width: '100%'}}
                                />
                            </GreenCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Battery Offered</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                <TableInput type={'checkbox'}
                                    checked={formData.batteryOffered}
                                    onChange={(e) => updateFormData('batteryOffered', e.target.checked)}
                                    style={{width: '100%'}}
                                />
                            </GreenCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <BlackCellBorderWhite>Battery Model</BlackCellBorderWhite>
                            <GreenCell style={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                <TableSelect value={formData.selectedBattery} onChange={(e) => updateFormData('selectedBattery', e.target.value)} style={{width: '100%'}}>
                                    <option value="" >None</option>
                                    {
                                        allProducts && allProducts.loaded && allProducts.data.Batteries && allProducts.data.Batteries.map(k => {

                                            return <option value={k.SKU} key={`battery-${k.SKU}`}>{k.SKU}</option>
                                        })
                                    }
                                </TableSelect>
                            </GreenCell>
                        </StyledTableRow>
                    </TableBody>
                </InstyleTable>
            </div>
        </>
    )
}